/**
 * @flow
 */
'use strict';

export const santeOcculaire1Codes = [
{"code":"    "},
{"code":" Pseudophakie"},
{"code":"+ brûlement OU"},
{"code":"+ rougeur parfois OU"},
{"code":"1ère Rx"},
{"code":"AIC étroit"},
{"code":"Absence de vision"},
{"code":"Accident voiture"},
{"code":"Allergie saionnière +++"},
{"code":"Allergies ?"},
{"code":"Amaurose fugax"},
{"code":"Amblyopie"},
{"code":"Amblyopie strabique"},
{"code":"Angiome faciale"},
{"code":"Anisocorie"},
{"code":"Anisométropie"},
{"code":"Apparence de esotropie"},
{"code":"Arthrite rhumatoide"},
{"code":"Artérite temporale"},
{"code":"Assymétrie c/d, bilan en ophtalmo"},
{"code":"Atrophie optique"},
{"code":"Atteinte du GOD"},
{"code":"BRAO"},
{"code":"BRVO"},
{"code":"Baisse vision +++"},
{"code":"Balance"},
{"code":"Blepharite"},
{"code":"Blepharite/sech.oculaire"},
{"code":"Blepharoplastie"},
{"code":"Blépharite"},
{"code":"Blépharospasme"},
{"code":"Bonne"},
{"code":"Bouchons lacrymaux"},
{"code":"Buckle"},
{"code":"CE mettalik intraoculaire retiré"},
{"code":"CRVO"},
{"code":"CVP déficient"},
{"code":"Capsulo"},
{"code":"Capsulotomie"},
{"code":"Cat traumatique"},
{"code":"Cataracte"},
{"code":"Cataracte cong."},
{"code":"Cecité congénitale nocturne"},
{"code":"Cellulite orbitaire"},
{"code":"Chalazion"},
{"code":"Chirurgie gl. lacrymal"},
{"code":"Chirurgie glaucome"},
{"code":"Chirurgie laser"},
{"code":"Chirurgie ptérygion"},
{"code":"Chirurgie rétine"},
{"code":"Chirurgie strabisme"},
{"code":"Chirurgie tumeur bénin"},
{"code":"Choriorétinite"},
{"code":"Chx canal lacrymal"},
{"code":"Chx cat. OU"},
{"code":"Chx cornée"},
{"code":"Chx kyste"},
{"code":"Chx orgelet"},
{"code":"Chx paupières"},
{"code":"Chx refractive"},
{"code":"Chx refractive LIO"},
{"code":"Cicatrice chorio-retinienne"},
{"code":"Cicatrice cornée"},
{"code":"Cicatrice rétinenne"},
{"code":"Colobome"},
{"code":"Complication chir."},
{"code":"Congé ophtalmo"},
{"code":"Cornées irrégulieres post lasik OU"},
{"code":"Cortisone"},
{"code":"Crosslinking"},
{"code":"Cryoscopie"},
{"code":"Crythérapie"},
{"code":"Cécité"},
{"code":"DMLA"},
{"code":"DMLA humide"},
{"code":"DMLA sèche"},
{"code":"Dacryocystorynostomy (DCR)"},
{"code":"Dacryoplastie"},
{"code":"Dacryostenose"},
{"code":"Daltonien"},
{"code":"Diplopie"},
{"code":"Diplopie ?"},
{"code":"Diplopie occasionnelle"},
{"code":"Diplopie sans Rx"},
{"code":"Diplopie vs flou ?"},
{"code":"Dispersion pigmentaire"},
{"code":"Djà fait enlever CE, ok vision"},
{"code":"Dmek"},
{"code":"Drusens"},
{"code":"Dsaek"},
{"code":"Dystrophie"},
{"code":"Dystrophie Cogan"},
{"code":"Dystrophie cornéenne"},
{"code":"Dystrophie endo."},
{"code":"Déchirure rétine"},
{"code":"Décollement rétine"},
{"code":"Démangeaison"},
{"code":"Endophtalmite"},
{"code":"Erosion"},
{"code":"Erosion récidivante"},
{"code":"Esotropie"},
{"code":"Exercice orthoptique"},
{"code":"Exophtalmie"},
{"code":"Exotropie"},
{"code":"Exotropie interm"},
{"code":"Faible myopie pre-op"},
{"code":"Flash"},
{"code":"Flash,floater"},
{"code":"Flash??"},
{"code":"Flashes"},
{"code":"Flashs occasionnels"},
{"code":"Floater"},
{"code":"Floater ?"},
{"code":"Floater, mieux"},
{"code":"Floater, stable"},
{"code":"Floaters"},
{"code":"Flottants stables"},
{"code":"Fort astigm."},
{"code":"Forte hypermétropie"},
{"code":"Glaucome"},
{"code":"Glaucome ?"},
{"code":"Greffe cornée"},
{"code":"Halos depuis chx"},
{"code":"Halos le soir"},
{"code":"Hemmoragie retinienne"},
{"code":"Herpès"},
{"code":"Histoplasmose"},
{"code":"Hx cellulite orbitaire"},
{"code":"Hx de C.E métal sans séquelles"},
{"code":"Hx de CCS"},
{"code":"Hx névrite optique"},
{"code":"Hypertonie"},
{"code":"Hémianopsie"},
{"code":"IMPLANT KAMRA"},
{"code":"Inconfort"},
{"code":"Inflamation chronique"},
{"code":"Inflamation cornée"},
{"code":"Inflammation MEO"},
{"code":"Inflammation oculaire"},
{"code":"Injection"},
{"code":"Injection + laser"},
{"code":"Injection DMLA"},
{"code":"Injection/Thrombose"},
{"code":"Intacts cornéen"},
{"code":"Iridotomie"},
{"code":"Irritation"},
{"code":"Irritis chronique"},
{"code":"Jamais porté lunette"},
{"code":"Keratite herpétique"},
{"code":"Keratite sèche"},
{"code":"Keratite virale"},
{"code":"Keratocône"},
{"code":"Keratoprothese"},
{"code":"Keratotomie radiaire"},
{"code":"Kyste"},
{"code":"Kyste irien"},
{"code":"Kyste maculaire"},
{"code":"Kératectomie "},
{"code":"Kératoplastie"},
{"code":"LIO multifocale"},
{"code":"LIO phake"},
{"code":"LIO toric"},
{"code":"Lactymoplastie"},
{"code":"Lagophtalmie"},
{"code":"Larmoiement"},
{"code":"Larmoiement chronique"},
{"code":"Laser glaucome"},
{"code":"Laser/ dechirure"},
{"code":"Laser?"},
{"code":"Lasik"},
{"code":"Lasik monovision"},
{"code":"Lasik/glaucome"},
{"code":"Lattice"},
{"code":"Lattices traité au laser"},
{"code":"Lymphome NO"},
{"code":"Lég. DMLA seche"},
{"code":"Maculopathie"},
{"code":"Maladie de Graves"},
{"code":"Membrane épi-maclaire"},
{"code":"Membrane épirétinienne"},
{"code":"Micro esotropie"},
{"code":"Migraines ophtalmiques"},
{"code":"Modification pigmentaire"},
{"code":"Monovision"},
{"code":"Myopie"},
{"code":"Myopie eleve pre-op"},
{"code":"Méningiome"},
{"code":"Naevus choroïdien"},
{"code":"Ne plisse pas les yeux"},
{"code":"Neavus"},
{"code":"Neuropathie optique ishémique"},
{"code":"Neuropathie rétrobulbaire"},
{"code":"Nodules cornéens"},
{"code":"Normal"},
{"code":"Normale"},
{"code":"Nouveau flottants"},
{"code":"Nystagmus"},
{"code":"Névrite optique"},
{"code":"OD plus faible"},
{"code":"OG plus faible"},
{"code":"Obstruction veineuse"},
{"code":"Occlusion artère centrale?"},
{"code":"Oculoplstie"},
{"code":"Oedeme maculaire"},
{"code":"Opacité cornée"},
{"code":"Orgelet"},
{"code":"Orthokératologie"},
{"code":"P.R.K."},
{"code":"P.V.D."},
{"code":"PCA pour trou/dechirure"},
{"code":"PIO élevé"},
{"code":"Papillite"},
{"code":"Paralysie"},
{"code":"Paralysie Bell"},
{"code":"Pars planite"},
{"code":"Pas LAT"},
{"code":"Pas Rx"},
{"code":"Pas brulement"},
{"code":"Pas cataractes, glc, strab, ambly"},
{"code":"Pas chirurgie"},
{"code":"Pas chx"},
{"code":"Pas chx. Trauma"},
{"code":"Pas chx/maladie "},
{"code":"Pas chx/maladie/trauma"},
{"code":"Pas de cataracte"},
{"code":"Pas de diplopie"},
{"code":"Pas de flash, floaters"},
{"code":"Pas de flott/VD"},
{"code":"Pas de glaucome"},
{"code":"Pas de halos"},
{"code":"Pas de picotement"},
{"code":"Pas de plainte"},
{"code":"Pas de rougeur"},
{"code":"Pas de strab, ambly"},
{"code":"Pas de sécheresse"},
{"code":"Pas dipl., mdet"},
{"code":"Pas diplopie"},
{"code":"Pas douleur"},
{"code":"Pas douleur, picotement"},
{"code":"Pas douleur, sécheresse"},
{"code":"Pas flas"},
{"code":"Pas flash"},
{"code":"Pas flash, "},
{"code":"Pas flash, diplopie"},
{"code":"Pas flash, floaters"},
{"code":"Pas flash, pas diplopie"},
{"code":"Pas flash, pas floater"},
{"code":"Pas flash,dipl, mdet"},
{"code":"Pas flash,dipl."},
{"code":"Pas flash,dipl., mdet"},
{"code":"Pas flash,floater,dipl."},
{"code":"Pas flash,floater,dipl., mdet"},
{"code":"Pas flash,floater,diplopie"},
{"code":"Pas flashes"},
{"code":"Pas flashes, diplopie"},
{"code":"Pas flashes, pas floaters"},
{"code":"Pas floater, dipl."},
{"code":"Pas floater, diplopie"},
{"code":"Pas floater,dipl., mdet"},
{"code":"Pas floaters"},
{"code":"Pas flottant"},
{"code":"Pas frottement"},
{"code":"Pas glc, cat, strab, ambly"},
{"code":"Pas glc, strab, ambly"},
{"code":"Pas goutte"},
{"code":"Pas gtts"},
{"code":"Pas maladie oculaire"},
{"code":"Pas maladie oculaire connue"},
{"code":"Pas maladie/trauma"},
{"code":"Pas photophobie"},
{"code":"Pas picotement, larmoiement, sécheresse"},
{"code":"Pas picottement/larmoiement"},
{"code":"Pas rougeur"},
{"code":"Pas rougeur, douleur"},
{"code":"Pas rougeur, douleur, picotement"},
{"code":"Pas rougeur, picotement"},
{"code":"Pas strab, dipl"},
{"code":"Pas strab., dipl."},
{"code":"Pas strabisme"},
{"code":"Pas strabisme cRx"},
{"code":"Pas strabisme,diplopie"},
{"code":"Pas sympt oculaire"},
{"code":"Pas sécheresse"},
{"code":"Pas trauma"},
{"code":"Pas trauma, rougeur, douleur"},
{"code":"Pas yeux secs"},
{"code":"Pattern en V"},
{"code":"Perte CV "},
{"code":"Perte vision "},
{"code":"Photocoagulation"},
{"code":"Photophobie"},
{"code":"Phénomène lumineux"},
{"code":"Picotement"},
{"code":"Pli maculaire"},
{"code":"Plisse des yeux"},
{"code":"Plug"},
{"code":"Points noirs"},
{"code":"Port cst Rx"},
{"code":"Porteur LC"},
{"code":"Prothèse OD"},
{"code":"Prothèse OG"},
{"code":"Pseudo-kyste"},
{"code":"Pseudophakie"},
{"code":"Pseudophakie multif"},
{"code":"Pseudophakie multif."},
{"code":"Pseudotumeur cerebri"},
{"code":"Ptose congénitale"},
{"code":"Ptérygion"},
{"code":"Pupille d Adie"},
{"code":"Quadranopsie"},
{"code":"RD proliférante"},
{"code":"Retinopathie centrale"},
{"code":"Retinopathie diabétique"},
{"code":"Retinoschisis"},
{"code":"Rougeur constante"},
{"code":"Rougeur intermittante"},
{"code":"Résolu sans sequelles "},
{"code":"Rétinite pigmentaire"},
{"code":"Rétinoblastome"},
{"code":"Rétinopathie séreuse"},
{"code":"Scleral Buckle"},
{"code":"Sclérite"},
{"code":"Scotome"},
{"code":"Secheresse"},
{"code":"Strabisme"},
{"code":"Strabisme ?"},
{"code":"Strabisme accomodatif"},
{"code":"Strabisme alternant"},
{"code":"Strabisme intermittent"},
{"code":"Strabisme si fatigué"},
{"code":"Suivi ophtalmo"},
{"code":"Suture paup."},
{"code":"Syndrôme doane"},
{"code":"Thrombose"},
{"code":"Thrombose ?"},
{"code":"Toxoplasmose"},
{"code":"TrabÉculoplastie"},
{"code":"Traité pour conv."},
{"code":"Trauma"},
{"code":"Trauma avec déchirure de la choroide"},
{"code":"Traumatisme"},
{"code":"Trou maculaire"},
{"code":"Trou rétinien"},
{"code":"Tx PRP (laser)"},
{"code":"Tx cache"},
{"code":"Tx laser (diab.)"},
{"code":"Ulcère"},
{"code":"Uvéite"},
{"code":"Uvéite antérieure"},
{"code":"Uvéite chronique"},
{"code":"VL brouillée"},
{"code":"Varicelle oculaire"},
{"code":"Vitrectomie"},
{"code":"Voit bien avec Rx"},
{"code":"Yeux alignés"},
{"code":"Yeux chauffent"},
{"code":"Yeux forcent"},
{"code":"Yeux rouges"},
{"code":"Yeux secs"},
{"code":"Zona"},
{"code":"Éblouissement chronique"},
{"code":"Énucléation"},
]
